
import { useState, useEffect } from 'react';
import { fetchEmailConfig, EmailConfig } from '@/services/api/emailConfig';
import { useEmail } from '@/context/EmailContext';

interface UseEmailConfigReturn {
  emailConfig: EmailConfig | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useEmailConfig = (): UseEmailConfigReturn => {
  const { userEmailConfig, loading: contextLoading } = useEmail();
  const [emailConfig, setEmailConfig] = useState<EmailConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Sync userEmailConfig from context to emailConfig state
  useEffect(() => {
    if (userEmailConfig) {
      console.log('📧 Using userEmailConfig from context:', userEmailConfig);
      setEmailConfig(userEmailConfig as EmailConfig);
      setLoading(false);
    } else if (!contextLoading) {
      // Fallback to fetching if context doesn't have it
      fetchConfig();
    }
  }, [userEmailConfig, contextLoading]);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      setError(null);
      const config = await fetchEmailConfig();
      setEmailConfig(config);
    } catch (err) {
      console.error('Failed to fetch email config:', err);
      setError('Failed to load email configuration');
    } finally {
      setLoading(false);
    }
  };

  return {
    emailConfig,
    loading,
    error,
    refetch: fetchConfig,
  };
};
